<template>
  <div class="template-home">
    <!-- Live stream widget (shown when stream is active) -->
    <v-row v-if="getStreamLive">
      <v-col cols="12" sm="12" md="6" class="pr-1">
        <LiveWidgetStream v-if="getSettings.enableLive"></LiveWidgetStream>
      </v-col>
      <v-col cols="12" sm="12" md="6" class="pl-0 content-stream-embed">
        <LiveStream></LiveStream>
      </v-col>
    </v-row>

    <!-- Home sections -->
    <template  v-for="section in orderedTopSections">
<!--      <TopSportsBar-->
<!--          v-if="section.id === 'top_sports_bar' && section.enabled"-->
<!--          :key="'top_sports_bar'" />-->

      <BannerCarousel
          v-if="section.id === 'banners_carousel' && section.enabled"
          :bannerType="'2'"
          :key="'banners'" />

      <PromoCarousel
          v-if="section.id === 'banners_promo' && section.enabled"
          :bannerType="'13'"
          :key="'banners'" />

<!--      <LatestWinsHorizontal-->
<!--          v-if="section.id === 'last_wins_center' && section.enabled"-->
<!--          :key="'last_wins_center'" />-->

      <BetBuilderWidgetScrollable  v-if="section.id === 'bb_proposal' && section.enabled" :key="'bb_proposal'"/>


      <LiveWidget
          v-if="section.id === '_live_widget' && getSettings.enableLive && getCountLive.length >= 10"
          :key="'_live_widget'" />

      <div
          v-if="section.id === 'featured_events' && section.enabled"
          :key="'featured_events'">
        <FeaturedEventsWidgetScrollable v-if="!getLoadingDetail" />
        <EventsBestPlayedWidgetScrollable v-if="!getLoadingDetail && hasFeaturedInitialFetch && (!getFeaturedEvents || getFeaturedEvents.length === 0)" />
      </div>

<!--      <div-->
<!--          v-if="section.id === 'section_live' && section.enabled"-->
<!--          :key="'section_live'">-->
<!--        <div>-->
<!--          <span class="section-title">-->
<!--            <svg  width="32" height="32" viewBox="0 0 16 16" fill="var(&#45;&#45;live)" xmlns="http://www.w3.org/2000/svg">-->

<!--  <path class="wave-outer" d="M12.9628 3.20912C12.6766 2.93029 12.2125 2.93029 11.9263 3.20912C11.6401 3.48794 11.6401 3.94001 11.9263 4.21883C12.436 4.71538 12.8404 5.30487 13.1163 5.95365C13.3921 6.60242 13.5341 7.29777 13.5341 8C13.5341 8.70223 13.3921 9.39758 13.1163 10.0464C12.8404 10.6951 12.436 11.2846 11.9263 11.7812C11.6401 12.06 11.6401 12.5121 11.9263 12.7909C12.2125 13.0697 12.6766 13.0697 12.9628 12.7909C13.6087 12.1617 14.121 11.4148 14.4706 10.5928C14.8201 9.77079 15 8.88975 15 8C15 7.11025 14.8201 6.22921 14.4706 5.40719C14.121 4.58517 13.6087 3.83827 12.9628 3.20912Z"></path>-->

<!--  <path class="wave-inner" d="M10.0422 5.11529C10.3284 4.83647 10.7925 4.83647 11.0787 5.11529C11.4708 5.49724 11.7818 5.95068 11.994 6.44972C12.2062 6.94876 12.3155 7.48363 12.3155 8.02379C12.3155 8.56395 12.2062 9.09881 11.994 9.59786C11.7818 10.0969 11.4708 10.5503 11.0787 10.9323C10.7925 11.2111 10.3284 11.2111 10.0422 10.9323C9.75595 10.6535 9.75595 10.2014 10.0422 9.92257C10.2982 9.67322 10.5012 9.37719 10.6397 9.0514C10.7783 8.72561 10.8496 8.37642 10.8496 8.02379C10.8496 7.67115 10.7783 7.32197 10.6397 6.99617C10.5012 6.67038 10.2982 6.37436 10.0422 6.12501C9.75595 5.84618 9.75595 5.39412 10.0422 5.11529Z"></path>-->

<!--  <path d="M8.05198 9.51147C8.90891 9.51147 9.60359 8.83477 9.60359 8.00002C9.60359 7.16526 8.90891 6.48856 8.05198 6.48856C7.19504 6.48856 6.50036 7.16526 6.50036 8.00002C6.50036 8.83477 7.19504 9.51147 8.05198 9.51147Z"></path>-->

<!--  <path class="wave-inner" d="M6.05604 5.11529C5.76981 4.83647 5.30574 4.83647 5.0195 5.11529C4.62741 5.49724 4.31638 5.95068 4.10418 6.44972C3.89198 6.94876 3.78276 7.48363 3.78276 8.02379C3.78276 8.56395 3.89198 9.09881 4.10418 9.59786C4.31638 10.0969 4.62741 10.5503 5.0195 10.9323C5.30574 11.2111 5.76981 11.2111 6.05604 10.9323C6.34228 10.6535 6.34228 10.2014 6.05604 9.92257C5.80007 9.67322 5.59702 9.37719 5.45848 9.0514C5.31995 8.72561 5.24865 8.37642 5.24865 8.02379C5.24865 7.67115 5.31995 7.32197 5.45848 6.99617C5.59702 6.67038 5.80007 6.37436 6.05604 6.12501C6.34228 5.84618 6.34228 5.39412 6.05604 5.11529Z"></path>-->

<!--  <path class="wave-outer" d="M3.03717 3.20912C3.3234 2.93029 3.78748 2.93029 4.07371 3.20912C4.35994 3.48794 4.35994 3.94001 4.07371 4.21883C3.56397 4.71538 3.15962 5.30487 2.88375 5.95365C2.60788 6.60242 2.46589 7.29777 2.46589 8C2.46589 8.70223 2.60788 9.39758 2.88375 10.0464C3.15962 10.6951 3.56397 11.2846 4.07371 11.7812C4.35994 12.06 4.35994 12.5121 4.07371 12.7909C3.78748 13.0697 3.3234 13.0697 3.03717 12.7909C2.39131 12.1617 1.87898 11.4148 1.52944 10.5928C1.1799 9.77078 1 8.88975 1 8C1 7.11025 1.1799 6.22921 1.52944 5.40719C1.87898 4.58517 2.39131 3.83827 3.03717 3.20912Z"></path>-->
<!--</svg>-->
<!--            {{$t('livenow')}}-->
<!--          </span>-->
<!--        </div>-->
<!--        <MarketLivePreview :show-more-event-button="false" :page-limit="5" :is-in-home-page="true" v-if="getViewMode === 'preview'"/>-->
<!--        <div class="w-full flex justify-center mt-3">-->
<!--          <button class="primary-button" @click="goLive()">{{$t('view_all_events')}}</button>-->

<!--        </div>-->
<!--      </div>-->

<!--      <div-->
<!--          v-if="section.id === 'tabs' && section.enabled && getAppSection !== 'live'"-->
<!--          :key="'tabs'"-->
<!--          id="home-tabs-section">-->
<!--        <smart-toolbar-->
<!--            :groups="filteredItemWidget"-->
<!--            :group-selected="itemActive"-->
<!--            :tabs-scrollable="true"-->
<!--            :show-expand-collapse="false"-->
<!--            :show-search="false"-->
<!--            @update:groupSelected="onSelectGroup"-->
<!--            v-if="!getLoadingDetail"-->
<!--        />-->
<!--        <div class="tabs-content-area">-->
<!--          <EventsBestPlayedWidget v-show="itemActive === 'mostPlayed'" ref="bestPlayedWidget" />-->
<!--          <StartingSoonViewTerminal v-show="itemActive === 'startingSoon'" ref="startingSoonWidget" />-->
<!--          <NextEventsWidget-->
<!--            v-show="itemActive === 'nextEvents'"-->
<!--            ref="nextEventsWidget"-->
<!--              key="next_event_preview" :limitEvent="5" :page="1" :closable="false"-->
<!--              :controlPagination="true" />-->
<!--        </div>-->
<!--      </div>-->
    </template>
    <div>
      <div class="fta-sticky-nav" v-if="featuredNavItems.length > 0">
        <div
            class="fta-nav-scroll-container"
            ref="ftaNavScroll"
            @mousedown="navStartDrag"
            @mouseleave="navStopDrag"
            @mouseup="navStopDrag"
            @mousemove="navDoDrag"
            @click.capture="navPreventClickIfDragged"
        >
          <div class="fta-nav-track" ref="ftaNavTrack">
            <button
                v-for="item in featuredNavItems"
                :key="'fnav_'+item.id"
                class="fta-nav-pill"
                :class="{ active: activeTournamentId === item.id }"
                @click="scrollToTournament(item.id)"
            >{{ item.name }}</button>
            <div class="fta-pill-indicator" ref="ftaPillIndicator"></div>
          </div>
        </div>
      </div>
      <FeaturedTournamentsTerminal/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LoadingSkeleton from "@/components/generic/LoadingSkeleton";
import TopSportsBar from "@/components/center_widgets/Previews/TopSportsBar.vue";
import MarketLivePreview from "@/components/center_widgets/Live/previews/MarketLivePreview.vue";
import EventsBestPlayedWidgetScrollable from "@/components/center_widgets/Previews/EventsBestPlayedWidgetScrollable.vue";
import smartToolbar from "@/components/generic/SmartToolbar.vue";

const FeaturedEventsWidgetScrollable = () => ({
  component: import('@/components/center_widgets/Previews/FeaturedEventsWidgetScrollable.vue'),
  loading: LoadingSkeleton,
  timeout: 200
})

const LiveWidget = () => ({
  component: import('@/components/center_widgets/LiveWidget'),
  loading: LoadingSkeleton,
  timeout: 200
})

const LiveWidgetStream = () => ({
  component: import('@/components/center_widgets/LiveWidgetStream'),
  loading: LoadingSkeleton,
  timeout: 200
})


const BannerCarousel = () => ({
  component: import('@/components/center_widgets/BannerCarousel.vue'),
  loading: LoadingSkeleton,
  timeout: 200
})

const PromoCarousel = () => ({
  component: import('@/components/center_widgets/PromoCarousel.vue'),
  loading: LoadingSkeleton,
  timeout: 200
})

const NextEventsWidget = () => ({
  component: import('@/components/center_widgets/NextEventsWidget'),
  loading: LoadingSkeleton,
  timeout: 200
})

const EventsBestPlayedWidget = () => ({
  component: import('@/components/center_widgets/EventsBestPlayedWidget'),
  loading: LoadingSkeleton,
  timeout: 200
})

const StartingSoonViewTerminal = () => ({
  component: import('@/components/terminal/StartingSoonViewTerminal'),
  loading: LoadingSkeleton,
  timeout: 200
})

const LiveStream = () => ({
  component: import('@/components/center_widgets/LiveStream'),
  loading: LoadingSkeleton,
  timeout: 200
})

const LatestWinsHorizontal = () => ({
  component: import('@/components/right_widgets/LatestWinsHorizontal.vue'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const BetBuilderWidgetScrollable = () => ({
  component: import('@/components/center_widgets/Previews/BetBuilderWidgetScrollable.vue'),
  loading: LoadingSkeleton,
  timeout: 200,
})

const FeaturedTournamentsTerminal = () => ({
  component: import('@/components/terminal/FeaturedTournamentsTerminal.vue'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'HomeViewTerminal',
  components: {
    TopSportsBar,
    MarketLivePreview,
    FeaturedEventsWidgetScrollable,
    EventsBestPlayedWidgetScrollable,
    smartToolbar,
    LiveWidget,
    LiveWidgetStream,
    PromoCarousel,
    NextEventsWidget,
    EventsBestPlayedWidget,
    StartingSoonViewTerminal,
    LiveStream,
    LatestWinsHorizontal,
    BetBuilderWidgetScrollable,
    BannerCarousel,
    FeaturedTournamentsTerminal,
  },
  data: () => ({
    itemActive: 'mostPlayed',
    navIsDragging: false,
    navHasDragged: false,
    navStartX: 0,
    navScrollLeft: 0,
    activeTournamentId: null,
  }),
  async mounted() {
    const first = this.filteredItemWidget[0]
    if (first) this.itemActive = first._id
  },
  beforeDestroy() {
    if (this._ftaObserver) {
      this._ftaObserver.disconnect();
      this._ftaObserver = null;
    }
  },
  computed: {
    ...mapGetters({
      'getViewMode': 'ui/getViewMode',
      'getAppSection': 'ui/getAppSection',
      'getCountLive': 'odds/getCountLive',
      'getSettings': 'cart/getSettings',
      'getStreamLive': 'settings/getStreamLive',
      'getGameConsole': 'settings/getGameConsole',
      'getLoadingDetail': 'detailPrematch/getLoadingDetail',
      'getRawEvents': 'startingSoon/getFormattedEvents',
      'isLoadingStartingSoon': 'startingSoon/isLoading',
      'getFeaturedEvents': 'featuredEvents/getFeaturedEvents',
      'isLoadingFeatured': 'featuredEvents/isLoadingFeatured',
      'hasFeaturedInitialFetch': 'featuredEvents/hasFeaturedInitialFetch',
      'getEnableMostPlayedWidget': 'settings/getEnableMostPlayedWidget',
      'getEnableNextEventsWidget': 'settings/getEnableNextEventsWidget',
      'getEnableStartingSoonWidget': 'settings/getEnableStartingSoonWidget',
      'getBestPlayedEvents': 'bestPlayed/getBestPlayedEvents',
      'getNextEvents': 'nextEvents/getFormattedEvents',
      'isLoadingNextEvents': 'nextEvents/isLoading',
      'isLoadingBestPlayed': 'bestPlayed/isLoadingBestPlayed',
      'getUiPersonalizationCenter': 'settings/getUiPersonalizationCenter',
      'getEventsDetail': 'detailPrematch/getEventsDetail',
      'getTournamentsActive': 'previewPrematch/getTournamentsActive',
      'getEventsLiveDetailActive': 'detailLive/getEventsLiveDetailActive',
      'getFeaturedTournaments': 'featuredEvents/getFeaturedTournaments',
      'getFeaturedPreview': 'previewPrematch/getFeaturedPreview',
    }),
    orderedTopSections() {
      const config = this.getUiPersonalizationCenter
      const tabIds = ['most_played', 'next_events', 'starting_soon']
      if (!config) {
        return [
          { id: 'top_sports_bar',   enabled: true, order: 1 },
          { id: 'banners',          enabled: true, order: 2 },
          { id: '_live_widget',     enabled: true, order: 2.5 },
          { id: 'featured_events',  enabled: true, order: 3 },
          { id: 'section_live',     enabled: true, order: 4 },
          { id: 'tabs',             enabled: true, order: 5 },
        ]
      }
      const standalone = config
          .filter(w => !tabIds.includes(w.id))
          .map(w => ({ id: w.id, enabled: w.enabled, order: w.order }))
      const tabItems = config.filter(w => tabIds.includes(w.id))
      const tabsEnabled = tabItems.some(w => w.enabled)
      const tabsOrder = tabItems.length ? Math.min(...tabItems.map(w => w.order)) : 5
      return [
        ...standalone,
        { id: '_live_widget', enabled: true, order: 2.5 },
        { id: 'tabs', enabled: tabsEnabled, order: tabsOrder },
      ].sort((a, b) => a.order - b.order)
    },
    mostPlayedSvg() {
      return `<svg width="32" height="32" viewBox="0 0 32 32" fill="rgb(255, 78, 78)" xmlns="http://www.w3.org/2000/svg"><path d="M16 29C10.4444 29 6 24.6667 6 19.25C6 14.9167 8.66667 10.3667 9.77778 8.63333L9.83505 8.54942C10.6067 7.41785 13.6195 3 16 3C16.6667 3 17.1111 3.43333 17.1111 4.08333C17.1111 6.56173 17.9088 8.96235 19.3015 10.9557C19.7375 10.3368 20.076 9.67095 20.2222 8.95825C20.2827 8.6633 20.508 8.43259 20.7903 8.30111C21.3433 7.98498 22.0025 8.09572 22.3333 8.63333C23.8889 11.0167 25 13.6167 25.6667 15.8917C25.8889 17.0833 26 18.275 26 19.25C26 24.6667 21.5556 29 16 29ZM16 26.8333C17.8889 26.8333 19.3333 25.425 19.3333 23.5833C19.3333 23.3262 19.2638 23.0012 19.1797 22.6083C19.1575 22.5047 19.1343 22.3964 19.1111 22.2833C19.0069 21.8259 18.8292 21.3446 18.6012 20.8507C18.5166 20.9348 18.4276 21.0149 18.3343 21.0908L18.3333 21.0917C18.2222 21.3083 17.8889 21.4167 17.6667 21.4167C17.3333 21.4167 17 21.3083 16.7778 21.0917C16.0126 20.1421 15.4651 19.1076 15.1627 18.0148C14.0922 19.3181 12.6667 21.6824 12.6667 23.5833C12.6667 25.425 14.1111 26.8333 16 26.8333Z"/></svg>`

    },
    nextEventsSvg() {
      return `<svg width="32" height="32" viewBox="0 0 32 32" fill="rgb(33, 168, 247)" xmlns="http://www.w3.org/2000/svg"><path d="M21.9177 16.9959C21.4434 19.8356 18.9745 22 16 22C12.6863 22 10 19.3137 10 16C10 13.0256 12.1644 10.5566 15.0042 10.0823C15.5489 9.9913 16 10.4478 16 11V16H21C21.5523 16 22.0087 16.4511 21.9177 16.9959Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M27 16C27 22.0751 22.0751 27 16 27C9.92487 27 5 22.0751 5 16C5 9.92487 9.92487 5 16 5C22.0751 5 27 9.92487 27 16ZM24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16Z"/></svg>`

    },
    homeItemWidget() {
      const config = this.getUiPersonalizationCenter
      const tabMap = { most_played: 'mostPlayed', next_events: 'nextEvents', starting_soon: 'startingSoon' }
      const svgMap = { mostPlayed: this.mostPlayedSvg, nextEvents: this.nextEventsSvg }
      if (config) {
        return config
            .filter(w => tabMap[w.id])
            .sort((a, b) => a.order - b.order)
            .map(w => ({ _id: tabMap[w.id], active: w.enabled }))
      }
      return [
        { _id: 'mostPlayed',   active: this.getEnableMostPlayedWidget },
        { _id: 'nextEvents',   active: this.getEnableNextEventsWidget  },
        { _id: 'startingSoon', active: this.getEnableStartingSoonWidget },
      ]
    },
    featuredNavItems() {
      const sources = new Set(this.getFeaturedTournaments.map(t => t.tournamentId + '#prematch'));
      return this.getFeaturedPreview
          .filter(p => sources.has(p.source))
          .map(p => ({ id: p.tournament.id, name: p.tournament.name }));
    },
    filteredItemWidget() {
      const hasStartingSoon = !this.isLoadingStartingSoon && this.getRawEvents && this.getRawEvents.length > 0
      const hasMostPlayed = this.isLoadingBestPlayed || (this.getBestPlayedEvents && this.getBestPlayedEvents.length > 0)
      const hasNextEvents = (this.getNextEvents && this.getNextEvents.length > 0)
      return this.homeItemWidget
          .filter(item => item.active)
          .filter(item => item._id !== 'startingSoon' || hasStartingSoon)
        .filter(item => item._id !== 'mostPlayed' || hasMostPlayed)
        .filter(item => item._id !== 'nextEvents' || hasNextEvents)
          .map(item => ({ name: this.$t(item._id), _id: item._id }))
    },
  },
  watch: {
    filteredItemWidget(items) {
      if (!items.find(i => i._id === this.itemActive)) {
        this.itemActive = items.length > 0 ? items[0]._id : 'mostPlayed'
      }
    },
    featuredNavItems(items) {
      if (items.length) {
        if (!this.activeTournamentId) this.activeTournamentId = items[0].id;
        this.$nextTick(() => {
          this.moveNavIndicator();
          this.setupScrollSpy();
        });
      }
    },
  },
  methods: {
    ...mapActions({
      'removeFromDetail': 'detailPrematch/removeFromDetail',
      'removeFromPreview': 'previewPrematch/removeFromPreview',
      'removeEventLiveDetail': 'detailLive/removeEventLiveDetail',
      'setViewMode': 'ui/setViewMode',
    }),
    goLive() {
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean)
      detailSources.forEach(source => this.removeFromDetail({ source }))

      const previewSources = [...(this.getTournamentsActive || [])]
      previewSources.forEach(source => this.removeFromPreview({ source }))

      const liveSources = [...(this.getEventsLiveDetailActive || [])]
      liveSources.forEach(source => this.removeEventLiveDetail(source))

      this.setViewMode({ mode: 'detail', section: 'live' })
      window.parent.postMessage({ type: 'liveSectionEntered' }, '*')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onSelectGroup(id) {
      if (id !== this.itemActive) {
        this.itemActive = id
      }
    },
    scrollToTournament(id) {
      this.activeTournamentId = id;
      this.$nextTick(() => this.moveNavIndicator());
      const el = document.getElementById('fta-tournament-' + id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    setupScrollSpy() {
      if (this._ftaObserver) {
        this._ftaObserver.disconnect();
        this._ftaObserver = null;
      }
      if (!this._visibleTids) this._visibleTids = new Set();
      else this._visibleTids.clear();

      const items = this.featuredNavItems;
      if (!items.length) return;

      this._ftaObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const tid = entry.target.getAttribute('data-spy-id');
          if (!tid) return;
          if (entry.isIntersecting) this._visibleTids.add(tid);
          else this._visibleTids.delete(tid);
        });
        const active = items.find(item => this._visibleTids.has(String(item.id)));
        if (active && this.activeTournamentId !== active.id) {
          this.activeTournamentId = active.id;
          this.$nextTick(() => this.moveNavIndicator());
        }
      }, {
        rootMargin: '-40px 0px -50% 0px',
        threshold: 0,
      });

      items.forEach(item => {
        const el = document.getElementById('fta-tournament-' + item.id);
        if (el) {
          el.setAttribute('data-spy-id', String(item.id));
          this._ftaObserver.observe(el);
        }
      });
    },
    moveNavIndicator() {
      const track = this.$refs.ftaNavTrack;
      const indicator = this.$refs.ftaPillIndicator;
      if (!track || !indicator) return;
      const activePill = track.querySelector('.fta-nav-pill.active');
      if (!activePill) { indicator.style.width = '0px'; return; }

      indicator.style.width = `${activePill.offsetWidth}px`;
      indicator.style.transform = `translateX(${activePill.offsetLeft}px)`;

      const scroll = this.$refs.ftaNavScroll;
      if (scroll) {
        const pillLeft = activePill.offsetLeft;
        const pillRight = pillLeft + activePill.offsetWidth;
        if (pillRight > scroll.scrollLeft + scroll.clientWidth) {
          scroll.scrollLeft = pillRight - scroll.clientWidth + 16;
        } else if (pillLeft < scroll.scrollLeft) {
          scroll.scrollLeft = pillLeft - 16;
        }
      }
    },
    navStartDrag(e) {
      const el = this.$refs.ftaNavScroll;
      if (!el) return;
      this.navIsDragging = true;
      this.navHasDragged = false;
      this.navStartX = e.pageX - el.offsetLeft;
      this.navScrollLeft = el.scrollLeft;
    },
    navStopDrag() {
      this.navIsDragging = false;
    },
    navDoDrag(e) {
      if (!this.navIsDragging) return;
      e.preventDefault();
      const el = this.$refs.ftaNavScroll;
      const x = e.pageX - el.offsetLeft;
      const walk = (x - this.navStartX) * 1.5;
      if (Math.abs(walk) > 5) this.navHasDragged = true;
      el.scrollLeft = this.navScrollLeft - walk;
    },
    navPreventClickIfDragged(e) {
      if (this.navHasDragged) e.stopPropagation();
    },
  },
}
</script>

<style scoped>

.template-home{
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.tabs-content-area {
  min-height: 600px;
}
.wave-inner {
  animation: broadcast-pulse 1.5s ease-in-out infinite;
  animation-delay: 0.2s;
}
.wave-outer {
  animation: broadcast-pulse 1.5s ease-in-out infinite;
  animation-delay: 0.4s;
}
@keyframes broadcast-pulse {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

.fta-sticky-nav {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--bg-body);
  width: 100%;
  box-shadow: inset 0 -2px 0 0 rgba(255, 255, 255, 0.15);
}

.fta-nav-scroll-container {
  overflow-x: auto;
  cursor: grab;
}
.fta-nav-scroll-container:active {
  cursor: grabbing;
}

@media (pointer: fine) {
  .fta-nav-scroll-container { scrollbar-width: thin; scrollbar-color: #555 #222; }
  .fta-nav-scroll-container::-webkit-scrollbar { display: none; }
}

@media (pointer: coarse) {
  .fta-nav-scroll-container::-webkit-scrollbar { display: none; }
  .fta-nav-scroll-container { scrollbar-width: none; }
}

.fta-nav-track {
  display: inline-flex;
  gap: 32px;
  padding: 0 12px;
  position: relative;
}

.fta-nav-pill {
  background-color: transparent;
  color: var(--text-op-50-platform, #888);
  border: none;
  padding: 12px 0;
  font-size: var(--font-size-xl);
  cursor: pointer;
  transition: color 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  text-transform: uppercase;
}

.fta-nav-pill:hover,
.fta-nav-pill.active {
  color: var(--text-platform, #fff);
}

.fta-pill-indicator {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 0;
  background: var(--text-platform, #fff);
  pointer-events: none;
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), width 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  will-change: transform, width;
  z-index: 2;
}

</style>
